import { render, staticRenderFns } from "./Inforlist.vue?vue&type=template&id=15433c32&scoped=true"
import script from "./Inforlist.vue?vue&type=script&lang=js"
export * from "./Inforlist.vue?vue&type=script&lang=js"
import style0 from "./Inforlist.vue?vue&type=style&index=0&id=15433c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15433c32",
  null
  
)

export default component.exports